<template>
  <Modal :id="'cmp-select-invoice-project'" @cancelled="onCancelClick">
    <template slot="header"> {{ $t("create") }} {{ $t("invoice") }} </template>
    <template slot="body">
      <SearchList
        :id="'invoice-projects'"
        :items="invoiceProjects"
        :keyProperty="'invoice_project_id'"
        :isSearchable="false"
        :label="'invoice_project_name'"
        :selectionNumber="'single'"
        @selected="onInvoiceProjectSelected"
        :loading="loading"
        :loadingText="loadingText"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">Close</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../modal/modal";
import SearchList from "../search-list/search-list";

export default {
  components: {
    Modal,
    SearchList,
  },
  props: {
    invoiceProjects: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    loadingText: {
      type: String,
      default: "Loading",
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  computed: {},
  methods: {
    onCancelClick: function (event) {
      this.$emit("cancelled", true);
    },
    onInvoiceProjectSelected(selected) {
      console.log({ "select-invoice-project-modal.vue:55 selected": selected });
      console.log({
        "select-invoice-project-modal.vue:57 this.invoiceProjects":
          this.invoiceProjects,
      });
      const item = this.invoiceProjects?.find((ip) => {
        if (ip.invoice_project_id == Array.from(selected)[0]) {
          return true;
        } else {
          return false;
        }
      });

      if (!item) {
        return;
      }
      console.log({'select-invoice-project-modal.vue:69 item' : item});

      this.$emit("selected", item);
    },
  },
};
</script>

<style lang="scss" scoped>
// .invoice-project--list {
//   max-height: 500px;
//   height: 500px;
//   overflow: auto;

//   .invoice-project--item {
//     cursor: pointer;
//     height: 40px;
//     display: flex;

//     flex-direction: column;
//     justify-content: center;

//     padding: 10px;

//     transition: 100ms ease-out;

//     &:hover {
//       background: var(--sprt-6);
//     }

//     &:nth-child(even) {
//       background-color: var(--sprt-8);
//       &:hover {
//         background: var(--sprt-6);
//       }
//     }
//   }
// }
</style>
